export const MAX_FILE_COUNT = 5;
export const MB_BYTES = 1024 * 1024;
export const MAX_SIZE_MB = 30;
export const MAX_SIZE_BYTES = MAX_SIZE_MB * MB_BYTES;

export const TEST_IDS = {
  documentDropzoneSpinner: 'document-dropzone-spinner',
};
